/* Tinnito clone (23.10). The donor's newer Shrine main.js adds the bundle gifts through <quantity-break-upsells>;
   our theme's main.js has no such component, so ADD TO CART here does what the donor's does:
   selected bundle quantity of Tinnito + the gifts that bundle unlocks (data-min-quantity) -> cart drawer.
   The drawer's "Check out" goes to Phoenix (tnp-checkout.js). A dropped add is retried once, then the theme form posts natively; Phoenix only with items in the cart. */
(function () {
  'use strict';
  var MAIN = 67835115143422;
  var BTN = '#ProductSubmitButton-template--26700778733933__main, [id^="SectionAtcBtn-template--26700778733933__"]';
  var busy = false;
  function qty() {
    var r = document.querySelector('input[name="quantity"][type="radio"]:checked');
    return r ? parseInt(r.value, 10) || 1 : 1;
  }
  function gifts(q) {
    var lab = document.querySelector('label[for="quantity' + q + '-template--26700778733933__main"]');
    var out = [];
    if (!lab) return out;
    lab.querySelectorAll('.quantity-break__upsell--gift[data-product]').forEach(function (g) {
      var id = parseInt(g.getAttribute('data-product'), 10);
      if (id && q >= (parseInt(g.getAttribute('data-min-quantity'), 10) || 1) && out.indexOf(id) < 0) out.push(id);
    });
    return out;
  }
  function toPhoenix() { if (window.phxGo) window.phxGo('/checkout'); else location.href = '/checkout'; }
  function post(items, secs) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: secs.join(','), sections_url: location.pathname })
    }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); });
  }
  function nativeSubmit() {   // last resort: the theme form's own POST /cart/add (no gifts, but never an empty checkout)
    var f = document.getElementById('product-form-template--26700778733933__main');
    if (f) { var q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = qty(); f.appendChild(q); HTMLFormElement.prototype.submit.call(f); }
  }
  function add(btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.classList.add('loading');
    var q = qty();
    var drawer = document.querySelector('cart-drawer');
    var secs = [];
    try { secs = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : []; } catch (e) {}
    var items;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }, function () { return { items: [] }; })
      .then(function (cart) {
        var have = (cart.items || []).map(function (i) { return i.variant_id; });
        items = [{ id: MAIN, quantity: q }];
        gifts(q).forEach(function (id) { if (have.indexOf(id) < 0) items.push({ id: id, quantity: 1 }); });
        return post(items, secs).catch(function () {          // one retry on a dropped request
          return new Promise(function (ok) { setTimeout(ok, 900); }).then(function () { return post(items, secs); });
        });
      })
      .then(function (res) {
        if (!drawer || !drawer.renderContents || !res.sections) return toPhoenix();   // items ARE in the cart here
        res.id = MAIN;
        drawer.classList.remove('is-empty');
        // our theme's renderContents swaps the drawer HTML first, then runs gift helpers that this donor
        // markup does not have and throws - the drawer content is already right, so just open it
        try { drawer.renderContents(res); } catch (e) { console.warn('[tnp-bundle] drawer post-render', e); }
        var filled = /micro-electric-acupuncture-pen|Tinnito/.test(drawer.innerHTML);
        if (!filled) return toPhoenix();
        if (drawer.open && !drawer.classList.contains('active')) setTimeout(function () { try { drawer.open(); } catch (e) { toPhoenix(); } }, 300);
      }, function (err) { console.error('[tnp-bundle] add failed twice', err); nativeSubmit(); })
      .then(function () { busy = false; if (btn) btn.classList.remove('loading'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(BTN);
    if (!b || b.closest('cart-drawer')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    add(b);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'product-form-template--26700778733933__main') return;
    e.preventDefault(); e.stopImmediatePropagation();
    add(f.querySelector('button[name="add"]'));
  }, true);
})();
